import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

/**
 * Makeup Look picker (standalone from preset system).
 * Styled to match Haircuts Studio preset grid sizing + scroll behavior.
 */
const MakeupLookPanel = ({ looks, selectedLookId, onSelect, disabled = false }) => {
  // Preload look thumbnails so they render immediately (no browser lazy placeholders).
  useEffect(() => {
    const urls = (Array.isArray(looks) ? looks : []).map((l) => l?.previewImage).filter(Boolean);
    urls.forEach((src) => {
      try {
        const img = new Image();
        img.decoding = 'async';
        img.src = src;
      } catch (e) {
        // ignore
      }
    });
  }, [looks]);

  if (!Array.isArray(looks) || looks.length === 0) return null;

  return (
    <div className={`relative ${disabled ? 'pointer-events-none opacity-60' : ''}`}>
      {/* Responsive grid: 2 columns on all screen sizes for bigger images */}
      <div className="grid grid-cols-2 gap-3 max-h-[600px] overflow-y-auto p-1">
        {looks.map((look) => {
          const isSelected = selectedLookId === look.id;

          return (
            <motion.button
              key={look.id}
              type="button"
              onClick={() => onSelect(look)}
              className={[
                'relative overflow-hidden rounded-xl border transition-all',
                isSelected
                  ? 'border-pink-500 ring-2 ring-pink-500/50'
                  : 'border-zinc-200 dark:border-white/10 hover:border-pink-300 dark:hover:border-pink-700',
              ].join(' ')}
              whileHover={!disabled ? { scale: 1.02 } : {}}
              whileTap={!disabled ? { scale: 0.98 } : {}}
              aria-pressed={isSelected}
            >
              <div className="aspect-square w-full overflow-hidden bg-zinc-100 dark:bg-zinc-800">
                <img
                  src={look.previewImage}
                  alt={look.name}
                  className="w-full h-full object-cover"
                  loading="eager"
                  decoding="async"
                  fetchPriority={isSelected ? 'high' : 'low'}
                  width={256}
                  height={256}
                />
              </div>

              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-2">
                <p className="text-white text-xs font-semibold text-center leading-tight">{look.name}</p>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default MakeupLookPanel;

